import renderPrgImage from '../../../source/programImg'

function AiContainerLoder({ handelClose }) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            className="aiModeSelectDiv"
        >
            Loading....
        </div>
    )
}

export default AiContainerLoder
